import React, { useEffect } from "react";
import Button from "../../button/Button";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink, faMultiply } from "@fortawesome/pro-regular-svg-icons";
import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import Cookies from "js-cookie";
import "./AnomalyNotificationCard.scss";

interface IProps {
    show: boolean;
    redirectUrl: string;
    setShow: (show: boolean) => void;
    icon: IconDefinition;
    title: string;
    description: string;
    buttonText: string;
    cookieKey?: string;
}

const NotifyRedirectCard = (props: IProps) => {
    const { t } = useTranslation();

    const redirectToInfinityEdgeAI = () => {
        window.location.href = props.redirectUrl;
    };

    const onCancel = () => {
        props.setShow(false);
    };

    const handleHide = (e) => {
        e.preventDefault();
        onCancel();
        if (props.cookieKey) {
            Cookies.set(props.cookieKey, "true", { expires: 30 });
        }
    };

    return (
        <div className={props.show ? "anomalyNotificationCard" : "anomalyNotificationCard hideAlert"}>
            <div className="anomalyNotificationCard_content_row">
                <div className="anomalyNotificationCard_content">
                    <div className="titleIconContainer">
                        <FontAwesomeIcon icon={props.icon} className="iconContainer" />
                        <div className="anomalyNotificationCard_title">{props.title}</div>
                    </div>
                    <div className="anomalyNotificationCard_message">{props.description}</div>
                </div>
                <Button variant="secondary" onClick={() => onCancel()}>
                    <FontAwesomeIcon icon={faMultiply} />
                </Button>
            </div>
            <div className="anomalyNotificationCard_content_row">
                <div className="buttonContainer">
                    <Button variant="secondary" onClick={redirectToInfinityEdgeAI}>
                        {props.buttonText} <FontAwesomeIcon icon={faExternalLink} style={{ marginLeft: "8px" }} />
                    </Button>
                    <Button variant="secondary" onClick={() => onCancel()}>
                        {t("Shared.cancel")}
                    </Button>
                </div>
                <div className="dontshow">
                    <a href="#" onClick={handleHide}>
                        {t("PresetSwticher.Requests.DontShow")}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default NotifyRedirectCard;
